import { Component, OnInit } from '@angular/core';
import { TableService } from '../service/table.service';

@Component({
  selector: 'app-table1',
  templateUrl: './table1.component.html',
  styleUrls: ['./table1.component.css']
})
export class Table1Component implements OnInit {

  public tableData : any;

  constructor(private tableService : TableService) { }

  ngOnInit() {
    this.tableService.getTableData(1).subscribe((res : any) => {
      this.tableData = res;
    })
  }

}
